import { useMutation } from '@tanstack/react-query'
import { startDictation } from '../../../data/dictation'
import { UserFriendlyError } from '../../../model/Error'
import { dictationKeys } from './dictation.keys'

export const useStartDictation = () => {
  return useMutation({
    mutationKey: dictationKeys.start,
    mutationFn: async () => {
      const { data, ok } = await startDictation()

      if (!ok || !data) {
        throw new UserFriendlyError('error', 'Impossible de démarrer la session de dictée')
      }

      return data
    },
  })
}
